export const APPLICATION_URL = import.meta.env.VITE_APPLICATION_HOST_URL;
export const IS_DEV = import.meta.env.VITE_IS_DEV === 'true';
export const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;
export const ENABLE_SENTRY = import.meta.env.VITE_ENABLE_SENTRY === 'true';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;
